class ScreenComponentData {
    constructor() {
        this.enabled = true;
    }
}

export { ScreenComponentData };
